import clsx from 'clsx'

import { type LocalizationNameObj, type LocaleCodeType, type LocaleNameKeyType, type LocalizationLink, type LocalizationFirstNameObj, type LocalizationLastNameObj } from '@/types/Localization'

const localizationLinkRegex = /\[\[.*\(link\)\]\]/g

export const replaceLinkFormat = (value: string, localizationLinks: LocalizationLink[]): JSX.Element => {
  let index = -1
  const newValue = value.replace(localizationLinkRegex, (match) => {
    const replaced = match.replace('(link)]]', '').replace('[[', '')
    index++
    const localizationLink = localizationLinks[index]
    const target = localizationLink.target ? `target="${localizationLink.target}"` : ''
    const rel = localizationLink.rel ? `rel="${localizationLink.rel}"` : ''

    return `<a class="${clsx('text-primary underline')}" href="${localizationLink.url}" ${target} ${rel}>${replaced}</a>`
  })

  return <span v-html={newValue} />
}

export const getLocalizationNameKey = (code: LocaleCodeType): LocaleNameKeyType => {
  if (code === 'en') {
    return 'name_en'
  }

  return 'name_th'
}

export const getLocalizationName = (odj: LocalizationNameObj, code: LocaleCodeType): string | null => {
  if (code === 'en') {
    return odj.name_en
  }

  return odj.name_th
}

export const getLocalizationFirstName = (odj: LocalizationFirstNameObj, code: LocaleCodeType): string => {
  if (code === 'en') {
    return odj.first_name_en
  }

  return odj.first_name_th
}

export const getLocalizationLastName = (odj: LocalizationLastNameObj, code: LocaleCodeType): string => {
  if (code === 'en') {
    return odj.last_name_en
  }

  return odj.last_name_th
}
